import gtmService from '../utils/gtmService'

export default defineNuxtPlugin(() => {
  window.didomiOnReady = window.didomiOnReady || []
  const gtmCallback = () => {
    gtmService.init()
  }
  if (!window.didomiOnReady.includes(gtmCallback)) {
    window.didomiOnReady.push(gtmCallback)
  }
})
